// Central style tokens for layout spacing, colors, z-indexes
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const colors = {
  bgPanel: '#ffffff',
  bgSoft: '#f5f7fa',
  border: '#e1e4e8',
  text: '#222',
  subtleText: '#555',
};

export const layout = {
  pageMaxWidth: '1600px',
};
